import { defineStore } from 'pinia'
import { useCookieManagerStore } from './cookies'
import type { Coupon } from '@/models/coupon'
import { IaCookie } from '@/models/cookie'

export const useCouponStore = defineStore('coupon', () => {
  const {
    notificationShown,
    notificationUnset,
    showNotification,
    dismissNotification,
    removeNotification,
  } = useNotification()

  const cookieManager = useCookieManagerStore()

  const couponCode = ref<string>()

  const getCouponCookie = () => {
    return cookieManager.getCookie<Coupon>(IaCookie.Coupon)
  }

  const setCoupon = (coupon: Coupon) => {
    set(couponCode, coupon.code)

    cookieManager.setCookie({
      name: IaCookie.Coupon,
      value: coupon,
    })

    if (notificationUnset.value)
      showNotification()
  }

  const removeCoupon = () => {
    set(couponCode, undefined)
    cookieManager.deleteCookie(IaCookie.Coupon)
    removeNotification()
  }

  const couponData = getCouponCookie()

  if (couponData) {
    set(couponCode, couponData.code)
    showNotification()
  }

  return {
    notificationShown,
    dismissNotification,
    couponCode,
    setCoupon,
    removeCoupon,
    getCouponCookie,
  }
})
